import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { NotificationFeedPageAnalyticsEffects } from './notification-feed-page-analytics.effects';
import { NotificationFeedStateEffects } from './notification-feed-state.effects';
import { NotificationFeedStateKey } from './notification-feed-state.model';
import { notificationFeedStateReducer } from './notification-feed-state.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(NotificationFeedStateKey, notificationFeedStateReducer),
    EffectsModule.forFeature([NotificationFeedStateEffects, NotificationFeedPageAnalyticsEffects]),
  ],
})
export class NotificationFeedStateModule {}
